module.exports = __webpack_public_path__ + "img/completion_left_2.fc020ea5.jpg";